import { CommonModule } from '@angular/common';
import {
  Inject,
  ModuleWithProviders,
  NgModule,
  Optional,
  Type,
} from '@angular/core';
import {
  ContentTypeConfig,
  SupportedTypeMap,
} from '@nibtravel/shared/util/models';
import {
  NgxContentfulRichTextModule,
  NodeRenderer,
} from 'ngx-contentful-rich-text';
import { CONTENTFUL_NODE_RENDERERS } from '@nibtravel/shared/util/constants';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { i18nModule } from '@nibtravel/shared/util/i18n';

import { ContentfulDirective } from './directives';
import {
  EmbeddedEntryComponent,
  EmbeddedEntryDirective,
} from './embedded-entry/embedded-entry.component';
import { SupportedUITypeMap } from './models/components.enum';
import { RichTextComponent } from './rich-text/rich-text.component';
import { ContentTypeRegistry } from './services/content-type-registry';
import { SnippetComponent } from './snippet/snippet.component';
import { ContentfulImagePipe } from './pipes';
import { CONTENTFUL_TYPE } from './types';
import { InlineEmbeddedEntryComponent } from './inline-embedded-entry/inline-embedded-entry.component';
import { WrapperComponent } from './wrapper/wrapper.component';

const nodeRenderers: Record<string, Type<NodeRenderer>> = {
  [BLOCKS.EMBEDDED_ENTRY]: EmbeddedEntryComponent,
  [INLINES.EMBEDDED_ENTRY]: InlineEmbeddedEntryComponent,
};

@NgModule({
  imports: [CommonModule, NgxContentfulRichTextModule, i18nModule],
  declarations: [
    RichTextComponent,
    EmbeddedEntryComponent,
    EmbeddedEntryDirective,
    ContentfulDirective,
    SnippetComponent,
    ContentfulImagePipe,
    InlineEmbeddedEntryComponent,
    WrapperComponent,
  ],
  exports: [
    RichTextComponent,
    ContentfulDirective,
    SnippetComponent,
    ContentfulImagePipe,
  ],
})
export class ContentfulModule {
  constructor(
    registry: ContentTypeRegistry,
    @Optional()
    @Inject(CONTENTFUL_TYPE)
    config: SupportedTypeMap
  ) {
    registry.register(SupportedUITypeMap);
    if (config != null) {
      registry.register(config);
    }
  }

  static forRoot(
    config?: ContentTypeConfig
  ): ModuleWithProviders<ContentfulModule> {
    return {
      ngModule: ContentfulModule,
      providers: [
        {
          provide: CONTENTFUL_TYPE,
          useValue: config?.types,
        },
        {
          provide: CONTENTFUL_NODE_RENDERERS,
          useValue: nodeRenderers,
        },
      ],
    };
  }
}
